"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _saveIcon = _interopRequireDefault(require("./save-icon.svg"));
var _downloadIcon = _interopRequireDefault(require("./download-icon.svg"));
var _wsSearch = require("./wsSearch");
var _state = require("printableWorksheets/state");
var _printableWorksheets = require("printableWorksheets");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var WSTeacherHeader = function WSTeacherHeader() {
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    activeGrade = _usePrintableWorkshee.activeGrade,
    subjectCode = _usePrintableWorkshee.subjectCode,
    worksheetSearchValue = _usePrintableWorkshee.worksheetSearchValue,
    userId = _usePrintableWorkshee.userId,
    defaultSearch = _usePrintableWorkshee.defaultSearch,
    savedCount = _usePrintableWorkshee.savedCount,
    downloadCount = _usePrintableWorkshee.downloadCount,
    setDefaultSearch = _usePrintableWorkshee.setDefaultSearch,
    setActiveScreen = _usePrintableWorkshee.setActiveScreen,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    showHeader = _useState2[0],
    toggleHeader = _useState2[1];
  var toggleDefaultSearch = function toggleDefaultSearch(value) {
    setDefaultSearch(value);
    value ? toggleHeader(true) : toggleHeader(false);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-teacher-header",
    "data-sentry-component": "WSTeacherHeader",
    "data-sentry-source-file": "wsTeacherHeader.tsx"
  }, showHeader && /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-teacher-header__left"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-test-id": "saved-worksheets",
    className: "ws-numbered-tag",
    onClick: function onClick() {
      return setActiveScreen(_state.PRINTABLE_WORKSHEET_SCREENS.SAVED);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-numbered-tag__icon"
  }, /*#__PURE__*/_react["default"].createElement(_saveIcon["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-numbered-tag__label"
  }, "Saved worksheets"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-numbered-tag__number"
  }, savedCount)), /*#__PURE__*/_react["default"].createElement("div", {
    "data-test-id": "downloaded-history",
    className: "ws-numbered-tag left-margin",
    onClick: function onClick() {
      return setActiveScreen(_state.PRINTABLE_WORKSHEET_SCREENS.DOWNLOADED);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-numbered-tag__icon"
  }, /*#__PURE__*/_react["default"].createElement(_downloadIcon["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-numbered-tag__label"
  }, "Download history"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-numbered-tag__number"
  }, downloadCount))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-teacher-header__right ".concat(!defaultSearch ? "increase-width" : "")
  }, /*#__PURE__*/_react["default"].createElement(_wsSearch.WSSearch, {
    defaultSearch: defaultSearch,
    subjectCode: subjectCode,
    toggleDefaultSearch: toggleDefaultSearch,
    worksheetSearchValue: worksheetSearchValue,
    gradeCode: activeGrade,
    userId: userId,
    searchPlaceholder: worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD ? "Search Printables..." : "Search ".concat(subjectCode, " worksheets..."),
    "data-sentry-element": "WSSearch",
    "data-sentry-source-file": "wsTeacherHeader.tsx"
  })));
};
var _default = exports["default"] = WSTeacherHeader;